import { createSelector } from '@reduxjs/toolkit';

// Base selector to get the favorites slice
const selectFavoritesState = (state) => state.favorites;

// Selector to get the favorites array, returns empty array if undefined or null
export const selectFavorites = createSelector(
  [selectFavoritesState],
  (favoritesState) => (favoritesState && Array.isArray(favoritesState.favorites)) 
    ? favoritesState.favorites 
    : [] // Fallback to an empty array
);

// Selector to check if an item is a favorite
export const isFavorite = (spaceId) =>
  createSelector([selectFavorites], (favorites) =>
    Array.isArray(favorites) && favorites.some((fav) => fav.id === spaceId)
  );

// Selector to count the number of favorites, ensures it doesn't throw if favorites is undefined
export const selectFavoritesCount = createSelector(
  [selectFavorites],
  (favorites) => Array.isArray(favorites) ? favorites.length : 0 // Default to 0 if favorites is not an array
);
